import type { Resource } from '../../';
export const country_countries_AL: Resource = {"default":"Albania"};
